<template>
  <div ref="countrySearchInput" class="country-search-input" id="country-search-input">
    <el-select
      filterable
      :popper-class="'visa-select-dropdown ' + size"
      :placeholder="countryPlaceholder"
      v-model.trim="query"
      @change="searchChange"
      :remote-method="countrySearch"
      remote no-data-text="暂无结果"
      >
      <el-option class="country-search"
        v-for="v in countryResult"
        :value="v.visa_country_id"
        :label="v.country+v.en_country+v.cn_country"
        :key="v.visa_country_id"
      >
        <a>
          <label>{{v.country}}</label> <span>{{v.visa_type_list.join(' ')}}</span>
        </a>
      </el-option>
    </el-select>
    <span class="search-icon"></span>

    <div v-show="showCountryTable" class="country-table-box">
      <country-table-letter :country-list="search"></country-table-letter>
    </div>
  </div>
</template>

<script>
import 'pinyin4js';
import CountryTableLetter from '../../../components/common/country-table-letter';
import sensorService from '../../../services/sensor-service';

export default {
  name: 'country-search-input',
  components: {
    CountryTableLetter,
  },
  props: {
    search: {
      type: Array,
      default() {
        return [];
      },
      required: true,
    },
    size: {
      type: String,
      default: 'small',
    },
  },
  data() {
    return {
      // 搜索栏
      countryPlaceholder: '搜索国家/地区',
      countryResult: [],
      query: '',
      showCountryTable: false,
    };
  },
  computed: {
    searchPinyinFormat() {
      return this.search.map(item => ({
        pinyin_shortcut: PinyinHelper.convertToPinyinString(item.country, '', PinyinFormat.FIRST_LETTER),
        ...item,
        country_pinyin_shortcut: PinyinHelper.convertToPinyinString(item.country, '', PinyinFormat.FIRST_LETTER),
        country_alias_pinyin_shortcut: item.country_alias ? PinyinHelper.convertToPinyinString(item.country_alias, '', PinyinFormat.FIRST_LETTER) : '',
        country_alias_pinyin: item.country_alias ? PinyinHelper.convertToPinyinString(item.country_alias, '', PinyinFormat.WITHOUT_TONE) : '',
        country_alias: item.country_alias || '',
      }));
    },
  },
  created() {
    document.addEventListener('click', this.listenerDocumentClick);
  },
  destroyed() {
    document.removeEventListener('click', this.listenerDocumentClick);
  },
  methods: {
    // 搜索跳转
    searchChange(query) {
      const from_type = {
        countries: 'country_list_search',
        index: 'index_search',
      };
      if (query) {
        const pageFrom = sensorService.getPageFrom();
        this.$router.push({ name: 'country', params: { id: query }, query: { from: from_type[this.$route.name], ...pageFrom } });
      }
    },
    countrySearch(query) {
      if (query !== '') {
        // 隐藏国家表
        this.showCountryTable = false;

        query = query.toLowerCase();

        this.countryResult = this.searchPinyinFormat.filter(v => v.cn_country.indexOf(query) > -1 ||
          v.en_country.toLowerCase().indexOf(query) > -1 ||
          v.country.indexOf(query) > -1 ||
          v.country_pinyin_shortcut.indexOf(query) > -1 ||
          v.country_alias_pinyin_shortcut.indexOf(query) > -1 ||
          v.country_alias_pinyin.indexOf(query) > -1 ||
          v.country_alias.indexOf(query) > -1,
        );
      } else {
        this.countryResult = [];
        // 展示国家表
        this.showCountryTable = true;
      }
    },
    listenerDocumentClick(e) {
      if (this.$refs.countrySearchInput.contains(e.target)) {
        this.showCountryTable = true;
      } else {
        this.showCountryTable = false;
      }
    },
  },
};
</script>

<style lang="less">

.country-search-input {
  position: relative;
  .el-select {
    width: 100%;
    .el-input{
      .el-input__inner{
        height: 40px;
        border: 1px solid #e9e9e9;
        &:hover{
          border: 1px solid #5e9be1;
        }
        &:focus{
          border: 1px solid #5e9be1;
        }
      }
    }
  }
  .search-icon{
    position: absolute;
    right: 10px;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 17px;
    background-image: url('../../../assets/imgs/index/search-icon.png');
    background-size: cover;
    background-repeat: no-repeat;
  }
  .country-table-box{
    position: absolute;
    top: 45px;
    left: 0;
    z-index: 10;
  }
}
.visa-select-dropdown{
  z-index: 99 !important;
  margin: 3px 0;
  border-radius: 4px;
  border: solid 1px #e9e9e9;
  .el-select-dropdown__wrap{
    max-height: 288px;
  }
  .el-select-dropdown__list{
    padding: 0;
  }
  .el-select-dropdown__item.hover, .el-select-dropdown__item:hover{
    background-color: #eff5fc;
    a{
      label{
        font-size: 14px;
        color: #5e9be1;
      }
    }
  }
  .el-select-dropdown__item{
    &+.el-select-dropdown__item{
      border-top: 1px solid #f0f0f0;
    }
    a{
      font-size: 0;
      label{
        font-size: 14px;
        color: #333333;
      }
      span{
        margin-left: 10px;
        font-size: 12px;
        color: #aaaaaa;
      }
    }
  }
}
.visa-select-dropdown.small{
  max-width: 360px;
}
.visa-select-dropdown.big{
  max-width: 1000px;
}
</style>



// WEBPACK FOOTER //
// src/pages/countries/components/country-search-input.vue